import {Text} from '@mantine/core';
import React from 'react';

import FlowchartRemoveNodeModal from 'ui-library/reactflow/nodes/modals/FlowchartRemoveNodeModal';

import type {
  RemovalConfirmation,
  RemovalConfirmationLabels,
} from '../../procedure-runs/conditions/useConditionReplicateRemoval';

interface ProcedureRunDesignFlowchartConfirmRemoveModalProps {
  confirmation: RemovalConfirmation;
}

export function getRemovalConfirmationSubtitle(labels: RemovalConfirmationLabels): React.ReactNode {
  return (
    <>
      {'Removing '}
      <Text component="span" weight={700}>
        {labels.nodeLabel}
      </Text>
      {' will also remove '}
      <Text component="span" weight={700}>
        {labels.conditionReplicateLabel}
      </Text>
      {' from all downstream unit operations'}
    </>
  );
}

export default function ProcedureRunDesignFlowchartConfirmRemoveModal({
  confirmation,
}: ProcedureRunDesignFlowchartConfirmRemoveModalProps): JSX.Element {
  return (
    <FlowchartRemoveNodeModal
      nodeNames={['']} // Avoid displaying a bulleted list of identical node names
      onRequestRemove={confirmation.onConfirm}
      onRequestClose={confirmation.onCancel}
      title="Remove condition replicate?"
      subtitle={getRemovalConfirmationSubtitle(confirmation.labels)}
    />
  );
}
